import selectorSagas from './selectorSagas'
import cestaSagas from './cestaSagas'
import userSagas from './userSagas'
import searchSagas from './searchSagas'
import selectorMotoSagas from './selectorMotoSagas'
import searchMotoSagas from './searchMotoSagas'
import appSetupSagas from './appSetupSagas'
import areaPrivadaSagas from './areaPrivadaSagas'
import revisionSagas from './revisionSagas'
import { all } from 'redux-saga/effects'
import clientVehiclesSagas from './clientVehiclesSagas'
import aireAcondicionadoSagas from './aireAcondicionadoSagas'
import revisionMotoSagas from '../../../moto/revisiones/store/matricula/revisionMotoMatriculaSaga'
import revisionMotoMarcasSagas from '../../../moto/revisiones/store/marcas/revisionMotoMarcasSaga'
import revisionMotoModelosSagas from '../../../moto/revisiones/store/modelos/revisionMotoModelosSaga'
import revisionMotoLeadsSagas from '../../../moto/revisiones/store/lead/revisionMotoLeadSaga'
import catalogoListSaga from '../../../shared/catalogo/store/list/catalogoListSaga'
import catalogoFilterValuesSaga from '../../../shared/catalogo/store/filter/catalogoFilterValuesSaga'
import permutarNeumaticosSagas from '../../../coche/cita-previa/permutar-neumaticos/store/permutarNeumaticosSagas'
import watchMantenimientoSaga from '../../../shared/mantenimiento/store/mantenimientoSaga'

export default function* () {
  while (true) {
    yield all([
      selectorSagas(),
      cestaSagas(),
      userSagas(),
      searchSagas(),
      appSetupSagas(),
      selectorMotoSagas(),
      searchMotoSagas(),
      areaPrivadaSagas(),
      revisionSagas(),
      clientVehiclesSagas(),
      aireAcondicionadoSagas(),
      revisionMotoSagas(),
      revisionMotoMarcasSagas(),
      revisionMotoModelosSagas(),
      revisionMotoLeadsSagas(),
      catalogoListSaga(),
      catalogoFilterValuesSaga(),
      permutarNeumaticosSagas(),
      watchMantenimientoSaga(),
    ])
  }
}
